import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChartRenderer from "../components/ChartRenderer";
import Dashboard from "../components/Dashboard";
import DashboardItem from "../components/DashboardItem";
const DashboardItems = [
  {
    id: 0,
    name: "Anzahl Veedel",
    vizState: {
      query: {
        measures: ["ODCEinwohner.count"],
        timeDimensions: [],
        dimensions: [],
        filters: []
      },
      chartType: "number"
    }
  },
  {
    id: 1,
    name: "Einwohner je Stadtteil",
    vizState: {
      query: {
        measures: ["ODCEinwohner.totalEW"],
        timeDimensions: [],
        dimensions: ["ODCEinwohner.name"],
        filters: []
      },
      chartType: "bar"
    }
  }
];

const DashboardPage = () => {
  const dashboardItem = item => (
    <Grid item xs={12} lg={6}>
      <DashboardItem title={item.name}>
        <ChartRenderer vizState={item.vizState} />
      </DashboardItem>
    </Grid>
  );

  const Empty = () => (
    <div
      style={{
        textAlign: "center",
        padding: 12
      }}
    >
      <Typography variant="h5" color="inherit">
        There are no charts on this dashboard. Use Playground Build to add one.
      </Typography>
    </div>
  );

  return DashboardItems.length ? (
    <Dashboard>{DashboardItems.map(dashboardItem)}</Dashboard>
  ) : (
    <Empty />
  );
};

export default DashboardPage;
